import Container from './components/container';

const App = () => {
  return (
    <Container />
  );
}

export default App;
